module.exports = __webpack_public_path__ + "img/illustration.f94d12ce.svg";